import { Action, createReducer, on } from '@ngrx/store';
import { loadPaymentsAction, loadPaymentsErrorAction, loadPaymentsSuccessAction, selectPaymentAction } from './payments.actions';
import { PaymentsState } from './payments.state';

const initialState = new PaymentsState();

const reducer = createReducer(
  initialState,
  on(loadPaymentsAction, (state) => {
    const newState = { ...state };
    newState.isLoading = true;
    newState.selectedPayment = null;
    return newState;
  }),
  on(loadPaymentsSuccessAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = null;
    newState.payments = payload.payments;
    return newState;
  }),
  on(loadPaymentsErrorAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = payload.failure;
    return newState;
  }),
  on(selectPaymentAction, (state, payload) => {
    const newState = { ...state };
    newState.selectedPayment = newState.payments.find((payment) => payment.id === payload.paymentId);
    return newState;
  })
);

export function paymentsReducer(state: PaymentsState | null, action: Action) {
  return reducer(state, action);
}
